import React from 'react';
import { useTranslation } from 'react-i18next';
import RadioButtonActive from 'src/assets/images/RadioButton.svg';
import RadioButtonInactive from 'src/assets/images/RadioButtonInactive.svg';
import {
    LineSeparator,
    FilterComponentSelector,
    FilterComponentLabels,
    FilterLabel,
    DefaultIndicator,
    RadioButton,
} from './FilterItemsRadio.styled';
import { useSelector } from 'react-redux';
import { logErrorToConsole } from 'src/utils/util';

const FilterItemsRadio = ({
    filterItem,
    setSelectedCalendarView,
    isDefault,
    isChecked,
    radioName,
    width,
    whiteSpace,
    overFlow,
    textOverflow,
    children,
    index,
    FiltersListslength,
    paddingBottom,
    smbWidth,
}) => {
    const { t } = useTranslation();
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    // useEffectWithErrorLogging(() => {
    //     const timer = setTimeout(() => console.log('Initial timeout!'), 5000);
    //     return () => clearTimeout(timer);
    //   }, []);
    return (
        <>
            <FilterComponentSelector
                paddingBottom={
                    FiltersListslength == index ? paddingBottom : null
                }
            > 
                <FilterComponentLabels htmlFor={`${filterItem.id}`}>
                    <input
                        type="radio"
                        id={`${filterItem.id}`}
                        name="Calendar View"
                        value={`${filterItem.name}`}
                        checked={isChecked}
                        onChange={() => {
                            try {
                            setSelectedCalendarView(filterItem, radioName);
                             } catch (error) {
                                 logErrorToConsole(error);
                             }
                        }}
                        style={{ display: 'none' }}
                    ></input>
                    <RadioButton
                        src={
                            isChecked ? RadioButtonActive : RadioButtonInactive
                        }
                        loading="eager"
                    />
                    {children ? (
                        children
                    ) : (
                        <>
                            <FilterLabel
                                color="#00000"
                                width={width}
                                smbWidth={smbWidth}
                                whiteSpace={whiteSpace}
                                overFlow={overFlow}
                                textOverflow={textOverflow}
                            >
                                {filterItem.name === 'All'
                                    ? t('common.allLabel')
                                    : filterItem.name}
                            </FilterLabel>
                            {(() => {
                                if (isDefault) {
                                    return (
                                        <DefaultIndicator
                                            width={isLanguageChanged && '53px'}
                                        >
                                            {t('filter.defaultLabel')}
                                        </DefaultIndicator>
                                    );
                                } else {
                                    return <></>;
                                }
                            })()}
                        </>
                    )}
                </FilterComponentLabels>

                <br />
            </FilterComponentSelector>
            {FiltersListslength ? (
                FiltersListslength !== index && <LineSeparator />
            ) : (
                <LineSeparator />
            )}
        </>
    );
};

export default FilterItemsRadio;
